import Vue from 'vue'
import VueRouter from 'vue-router'
const Layout = () => import(/* webpackChunkName: "layout" */ '../layout/layout.vue')
const Login = () => import(/* webpackChunkName: "login" */ '../views/login.vue')
const SellerList = () => import(/* webpackChunkName: "home" */ '../views/seller-list')
const AddExpressCode = () => import(/* webpackChunkName: "home" */ '../views/add-express-code')
const ImportExpressCode = () => import(/* webpackChunkName: "home" */ '../views/add-express-code/import')
const NextFamily = () => import(/* webpackChunkName: "home" */ '../views/next-family')
const NextFamilyMessage = () => import(/* webpackChunkName: "home" */ '../views/next-family-message')
// const SalesClaim = () => import(/* webpackChunkName: "home" */ '../views/sales-claim')
const System = () => import(/* webpackChunkName: "system" */ '../views/system')
const UserManage = () => import(/* webpackChunkName: "system" */ '../views/system/user-manage')
const ProblemType = () => import(/* webpackChunkName: "system" */ '../views/system/problem-type')
const OrganizeManage = () => import(/* webpackChunkName: "system" */ '../views/system/organize-manage')
const ProcessResult = () => import(/* webpackChunkName: "result" */ '../views/results')
const Withdraw = () => import(/* webpackChunkName: "result" */ '../views/results/withdraw')
const Destruction = () => import(/* webpackChunkName: "result" */ '../views/results/destruction')
const PayFor = () => import(/* webpackChunkName: "result" */ '../views/results/pay-for')
const Pending = () => import(/* webpackChunkName: "result" */ '../views/results/pending')
const ChangeOrder = () => import(/* webpackChunkName: "result" */ '../views/results/change-order')
const Show = () => import(/* webpackChunkName: "result" */ '../views/home.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '/base',
    redirect: '/show',
    component: Layout,
    children: [
      {
        path: '/show',
        name: 'show',
        component: Show,
        meta: {
          title: '系统首页',
          show: true,
          keepAlive: false
        }
      },
      {
        path: '/home',
        name: 'home',
        component: AddExpressCode,
        meta: {
          title: '新建单号',
          show: true,
          keepAlive: false
        }
      },
      {
        path: '/sellerList',
        name: 'sellerList',
        component: SellerList,
        meta: {
          title: '卖家单号列表',
          show: true,
          keepAlive: false
        }
      },
      {
        path: '/results',
        name: 'results',
        component: ProcessResult,
        meta: {
          title: '卖家批量列表',
          show: true,
          keepAlive: false
        },
        children: [
          {
            path: '/pending',
            name: 'pending',
            component: Pending,
            meta: {
              title: '退款',
              show: true,
              keepAlive: false
            }
          },
          {
            path: '/changeOrder',
            name: 'changeOrder',
            component: ChangeOrder,
            meta: {
              title: '改派',
              show: true,
              keepAlive: false
            }
          },
          {
            path: '/withdraw',
            name: 'withdraw',
            component: Withdraw,
            meta: {
              title: '退仓',
              show: true,
              keepAlive: false
            }
          },
          {
            path: '/payFor',
            name: 'payFor',
            component: PayFor,
            meta: {
              title: '赔偿',
              show: true,
              keepAlive: false
            }
          },
          {
            path: '/destruction',
            name: 'destruction',
            component: Destruction,
            meta: {
              title: '销毁',
              show: true,
              keepAlive: false
            }
          }
        ]
      },
      // {
      //   path: '/salesClaim',
      //   name: 'salesClaim',
      //   component: SalesClaim,
      //   meta: {
      //     title: '销售认领列表',
      //     show: true,
      //     keepAlive: false
      //   }
      // },
      {
        path: '/nextFamily',
        name: 'nextFamily',
        component: NextFamily,
        meta: {
          title: '下家单号列表',
          show: true,
          keepAlive: false
        }
      },
      {
        path: '/message',
        name: 'message',
        component: NextFamilyMessage,
        meta: {
          title: '下家留言',
          show: false,
          keepAlive: false
        }
      },
      {
        path: '/import',
        name: 'import',
        component: ImportExpressCode,
        meta: {
          title: '批量导入',
          show: true,
          keepAlive: false
        }
      },
      {
        path: '/system',
        name: 'system',
        component: System,
        meta: {
          title: '系统管理',
          show: true,
          keepAlive: false
        },
        children: [
          {
            path: '/organize',
            name: 'organize',
            component: OrganizeManage,
            meta: {
              title: '组织管理',
              show: true,
              keepAlive: false
            }
          },
          {
            path: '/user',
            name: 'user',
            component: UserManage,
            meta: {
              title: '用户管理',
              show: true,
              keepAlive: false
            }
          },
          {
            path: '/problem',
            name: 'problem',
            component: ProblemType,
            meta: {
              title: '问题类型',
              show: true,
              keepAlive: false
            }
          }
        ]
      }
      // {
      //   path: '/addLucky',
      //   name: 'addLucky',
      //   component: addLucky,
      //   meta: {
      //     title: '新增福袋',
      //     keepAlive: false,
      //     show: false
      //   }
      // },
      // {
      //   path: '/drawPrize',
      //   name: 'drawPrize',
      //   component: DrawPrize,
      //   meta: {
      //     title: '奖品仓库',
      //     keepAlive: false,
      //     show: true
      //   }
      // }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]

const router = new VueRouter({
  routes
})

export default router
